import React, {Suspense} from 'react';
import ReactDOM from 'react-dom';
import './index.scss';
import App from './App';
import PartnersPage from './partners';
import PartnerDetails from './partnerDetails';

import * as serviceWorker from './serviceWorker';

import { BrowserRouter, Redirect, Route, Switch } from 'react-router-dom';

import "../node_modules/jquery/dist/jquery.min.js";
import "../node_modules/popper.js/dist/umd/popper.js";
import "../node_modules/bootstrap/dist/js/bootstrap.min.js";
import '../node_modules/font-awesome/css/font-awesome.min.css';

import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.min.css';

import 'bootstrap/dist/css/bootstrap.css';
import Loading from "./shared/components/loading";
import SalomRegions from './components/salomRegions';

// import Admin from './admin'
// import Login from './admin/components/login'
// import Files from './files'
const Admin = React.lazy(() => import ('./admin'))
const Login = React.lazy(() => import('./admin/components/login'))
const Files = React.lazy(() => import('./files'))

ReactDOM.render(
    <div>
        <ToastContainer
            position="bottom-right"
            autoClose={5000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnVisibilityChange
            draggable
            pauseOnHover
        />

        <BrowserRouter basename="/">
            <Switch>
                <Route exact path='/' component={PartnersPage} />
                {/* <Route exact path='/salom-regions' component={SalomRegions} /> */}
                <Route exact path='/partners' component={PartnersPage} />
                <Route exact path='/partners/search' component={PartnersPage} />
                <Route exact path='/partners/:id' component={PartnerDetails} />

                <Route exact path='/files'>
                  <Suspense fallback={<Loading />}>
                    <Files/>
                  </Suspense>
                </Route>
                <Route path='/admin'>
                  <Suspense fallback={<Loading />}>
                    <Admin/>
                  </Suspense>
                </Route>
                <Route path='/login'>
                  <Suspense fallback={<Loading />}>
                    <Login />
                  </Suspense>
                </Route>

                <Route path="*">
                    <Redirect to="/" />
                </Route>
            </Switch>
        </BrowserRouter>
    </div>,
    document.getElementById('root')
);



serviceWorker.unregister();
